module.exports = __webpack_public_path__ + "img/001.6aa98a37.png";